import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取线路列表
 * @param params
 */
export const getRoteList = (params) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/queryLinePage',
    // url: 'http://192.168.1.131:38000/lineAdmin/queryLinePage',
    method: 'post',
    data: params
  })
}

/**
 *获取所有上架线路
 */
export const getUpRoute = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/getLineList',
    // url: 'http://192.168.1.131:38000/lineAdmin/getLineList',
    method: 'get'
  })
}

/**
 * 根据线路id获取线路详情
 * @param lineId
 */
export const getRoteInfoById = (lineId) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/queryLineInfoById/${lineId}`,
    // url: `http://192.168.1.131:38000/lineAdmin/queryLineInfoById/${lineId}`,
    method: 'post'
  })
}

/**
 * 获取所有的业务城市
 */
export const queryAllCity = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/queryAllCity',
    // url: 'http://192.168.1.131:38000/lineAdmin/queryAllCity',
    method: 'post'
  })
}

/**
 * 获取所有的站点
 */
export const queryAllFstation = () => {
  return request({
    url: env.ferryUrl + '/lineAdmin/queryAllFstation',
    // url: 'http://192.168.1.131:38000/lineAdmin/queryAllFstation',
    method: 'get'
  })
}

/**
 * 新增线路
 * @param data
 */
export const addRoute = (data) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/addLine',
    // url: 'http://192.168.1.131:38000/lineAdmin/addLine',
    method: 'post',
    data
  })
}

/**
 * 上下架线路
 * @param lineId
 * @param status
 */
export const changeRouteStatus = (lineId, status) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/upOrOffShelfLineById/${lineId}/${status}`,
    // url: `http://192.168.1.131:38000/lineAdmin/upOrOffShelfLineById/${lineId}/${status}`,
    method: 'post'
  })
}

/**
 * 判断当前线路是否绑定站点规则
 */
export const lineIsBindStationRule = (lineId) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/judgeLineIsBindStationRule/${lineId}`,
    // url: `http://192.168.1.131:38000/lineAdmin/judgeLineIsBindStationRule/${lineId}`,
    method: 'post'
  })
}

/**
 * 编辑线路
 * @param data
 */
export const updateRoute = (data) => {
  return request({
    url: env.ferryUrl + '/lineAdmin/updateLineInfo',
    // url: 'http://192.168.1.131:38000/lineAdmin/addLine',
    method: 'post',
    data
  })
}

/**
 * 根据地级归属获取站点
 * @param areaManageId
 */
export const getStationByAreaId = (areaManageId) => {
  return request({
    url: env.ferryUrl + `/lineAdmin/queryFStationByAreaManageId/${areaManageId}`,
    // url: `http://192.168.1.131:38000/lineAdmin/queryLineInfoById/${lineId}`,
    method: 'GET'
  })
}

/**
 * 获取老系统线路列表
 * @returns
 */
export const getLineList = () => {
  return request({
    url: env.ferryUrl + '/lineConfig/lineList',
    method: 'GET'
  })
}
